/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedDocumentationStatusList200,
  GetApiV1CourseregistrationSharedDocumentationStatusList401,
  GetApiV1CourseregistrationSharedDocumentationStatusList500,
  GetApiV1CourseregistrationSharedDocumentationStatusListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedDocumentationStatusList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedDocumentationStatusList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentationStatusList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedDocumentationStatusList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentationStatusList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedDocumentationStatusList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentationStatusList500>;

export const getApiV1CourseregistrationSharedDocumentationStatusListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedDocumentationStatusList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedDocumentationStatusListQueryResponse>;
